import i18n from 'i18n'
import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"

const OPTIONS = [
    { label: 'Fixed Date', value: 1 },
    { label: 'Random Month', value: 2 },
]

const DO_KEY = { 1: 'admin:competitionForm.fixedDate', 2: 'admin:scheduler.randomMonth' }

export default function SelectMonth({...props}) {

    const myProps = {
        placeholder: '', label: i18n.t('common:filters.selectDateOption'),
        firstSelect: true, isClearable: true, options: OPTIONS,
        formatOptionLabel: opt => i18n.t(DO_KEY[opt?.value] || '', { defaultValue: opt?.label }),
        icon: {icon: 'calendar-day'}, isMulti: true,
        ...props
    }

    return <SelectSeeker {...myProps} />
}